import { Link } from "react-router-dom";

/** Fallback page rendered for any unknown route. */
export default function NotFound() {
    return (
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-center px-5 py-20 text-center sm:px-8 sm:py-32">
            <h1 className="text-5xl font-bold text-vb-text sm:text-7xl">404</h1>
            <p className="mt-4 max-w-md text-sm text-vb-text-soft">
                The page you are looking for does not exist or may have been moved.
            </p>
            <Link to="/" className="btn-primary mt-8">
                Return Home
            </Link>
        </div>
    );
}
